import { Stack, TextField, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { Message } from '../../../components/Message';
import { saveNewTel, saveNewEmail, saveNewPassword } from '../../../helpers/userMessage';
import { useForm } from '../../../hooks/useForm';


export const BasicForm = ({ label, buttonLabel, reset }) => {

    const [update, setUpdate] = useState(false)
    const [body, setBody] = useState({})

    const handleClick = (e) => {
        e.preventDefault();
        setBody({ email: e.target.campo?.value, tel: e.target.campo?.value })
        setUpdate(!update)
    }


    return (
        <Stack flexDirection='row' width='100%' justifyContent='space-around' alignItems='baseline' pb='1rem' component='form' onSubmit={handleClick}>
            <TextField
                name='campo'
                label={label}
                type={(label === 'Email') ? 'email' : 'search'}
                variant="standard"
            />
            <Button variant='outlined' type='submit' >{buttonLabel}</Button>
            {update && <Message setIsCreate={setUpdate} method='PUT' messages={(label === 'Email') ? saveNewEmail : saveNewTel} body={body} reset={reset}/>}
        </Stack>
    )
}

export const PassForm = ({ reset }) => {

    const [match, setMatch] = useState(true);
    const [update, setUpdate] = useState(false);
    const [body, setBody] = useState({})
    const [formValues, handleInputChange] = useForm({
        pass: '', repeatPass: ''
    });

    const { pass, repeatPass } = formValues

    const handleNewPassword = (e) => {
        e.preventDefault();
        if (pass === repeatPass) {
            setMatch(true)
            setBody({ password: pass })
            setUpdate(!update)
        } else {
            setMatch(false)
        }
    }

    return (
        <Stack alignItems='center' width='100%' >
            <Stack flexDirection='row' width='100%' justifyContent='space-around' alignItems='baseline' pb='1rem' flexWrap='wrap' gap={2} component='form' onSubmit={handleNewPassword}>
                <TextField
                    id="new_pass"
                    label='Nueva contraseña'
                    type="password"
                    variant="standard"
                    name='pass'
                    value={pass}
                    onChange={handleInputChange}
                />
                <TextField
                    id="repeat_pass"
                    label='Repetir contraseña'
                    type="password"
                    variant="standard"
                    name='repeatPass'
                    value={repeatPass}
                    onChange={handleInputChange}
                />
                <Button variant='outlined' type='submit'> Guardar contraseña</Button>
            </Stack>
            {!match && <Typography variant="subtitle2" color='red' >Las contraseñas no coinciden</Typography>}
            {update && <Message setIsCreate={setUpdate} method='PUT' messages={saveNewPassword} body={body} reset={reset} />}
        </Stack>
    )
}